uniform float uTime;
uniform float uBass;
uniform float uMid;
uniform float uHigh;
uniform float uSize;
uniform float uActive;
uniform float uShapeA;
uniform float uShapeB;
uniform float uMorphT;

attribute float aRandom;
attribute vec3  aPosCube;
attribute vec3  aPosTorus;
attribute vec3  aPosIco;
attribute vec3  aPosTknot;

varying float vRandom;
varying float vElevation;

vec3 pick(float idx) {
    if (idx < 0.5) return position;
    if (idx < 1.5) return aPosCube;
    if (idx < 2.5) return aPosTorus;
    if (idx < 3.5) return aPosIco;
    return aPosTknot;
}

void main() {
    float t   = smoothstep(0.0, 1.0, uMorphT);
    vec3  pos = mix(pick(uShapeA), pick(uShapeB), t);

    float bassWave = sin(uTime * 1.8 + aRandom * 6.283) * uBass * 0.3;
    float midWave  = cos(uTime * 2.7 + aRandom * 3.141) * uMid  * 0.15;

    pos = pos * (1.0 + bassWave + midWave);

    vec4 modelPosition = modelMatrix * vec4(pos, 1.0);
    vec4 viewPosition  = viewMatrix  * modelPosition;
    gl_Position = projectionMatrix * viewPosition;

    float sizeBoost = 1.0 + uHigh * 1.5 + uBass * 0.5;
    gl_PointSize = uSize * sizeBoost * uActive;
    gl_PointSize *= (1.0 / -viewPosition.z);

    vRandom    = aRandom;
    vElevation = pos.y;
}
